import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

interface IProps {
  width?: number;
  height?: number;
  color?: string;
  style?: Record<string, any>;
}

function Card(props: IProps) {
  const {
    width = props.width || 20,
    height = props.height || 16,
    color = props.color || "#111111",
    style,
  } = props;
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 22 18"
      fill="none"
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M19.4286 2.32143C19.7625 2.32143 20.0357 2.59464 20.0357 2.92857V4.14286H1.82143V2.92857C1.82143 2.59464 2.09464 2.32143 2.42857 2.32143H19.4286ZM20.0357 7.78571V15.0714C20.0357 15.4054 19.7625 15.6786 19.4286 15.6786H2.42857C2.09464 15.6786 1.82143 15.4054 1.82143 15.0714V7.78571H20.0357ZM2.42857 0.5C1.08906 0.5 0 1.58906 0 2.92857V15.0714C0 16.4109 1.08906 17.5 2.42857 17.5H19.4286C20.7681 17.5 21.8571 16.4109 21.8571 15.0714V2.92857C21.8571 1.58906 20.7681 0.5 19.4286 0.5H2.42857ZM4.55357 12.0357C4.04888 12.0357 3.64286 12.4417 3.64286 12.9464C3.64286 13.4511 4.04888 13.8571 4.55357 13.8571H6.375C6.87969 13.8571 7.28571 13.4511 7.28571 12.9464C7.28571 12.4417 6.87969 12.0357 6.375 12.0357H4.55357ZM9.41071 12.0357C8.90603 12.0357 8.5 12.4417 8.5 12.9464C8.5 13.4511 8.90603 13.8571 9.41071 13.8571H13.6607C14.1654 13.8571 14.5714 13.4511 14.5714 12.9464C14.5714 12.4417 14.1654 12.0357 13.6607 12.0357H9.41071Z"
        fill={color}
      />
    </Svg>
  );
}

export default Card;
